var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-application--wrap"},[_c('the-layout-drawer'),(_vm.$route.meta.displayToolBar)?_c('the-layout-toolbar'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_vm._t("default")],2)],1)],1),_c('the-layout-fab'),_c('the-layout-to-top-fab'),_c('the-layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }